import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { InfoIcon } from 'src/domains/layouts/shared/assets/iconography/interface/InfoIcon';

interface TooltipContentPropsType { 
    isActive: boolean;
}

export const TooltipContainer = styled('button', { label: 'TooltipContainer' })`
    background: none;
    border: none;
    padding: 0;
    height: 16px;
    width: 16px;
    color: currentcolor;
`;

export const Icon = styled(InfoIcon, { label: 'Icon' })`
    width: 16px;
    fill: currentcolor;
`;

export const TooltipTriangle = withConfig(theme => styled('div', { label: 'TooltipTriangle' })<TooltipContentPropsType>`
    position: absolute;
    top: 18px;
    width: 0;
    height: 0;
    margin-right: 12px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: ${theme.star.zIndexLevelBase.baseUp};
    border-bottom: 8px solid ${theme.star.tooltip.bgColorSecondary};
    visibility: ${({ isActive }): string => isActive ? 'visible' : 'hidden'};
`);

export const TooltipContent = withConfig(theme => styled('div', { label: 'TooltipContent' })<TooltipContentPropsType>`
    position: absolute;
    top: 26px;
    width: 100%;
    left: 0;
    background: ${theme.star.tooltip.bgColorSecondary};
    color: ${theme.star.tooltip.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    padding: 4px 8px;
    z-index: ${theme.star.zIndexLevelBase.baseUp};
    visibility: ${({ isActive }): string => isActive ? 'visible' : 'hidden'};
    text-align: left;
`);
